import React from "react";
import { Helmet } from "react-helmet-async";
import SeoHead, { MAIN_SITE_URL } from "./SiteSeo";
import SiteLayout from "./SiteLayout";
import { SmartLink } from "./SiteHeader";
import { HowItWorks, FinalCta } from "./sections";
import { REGIONS } from "./cities";
import { cityName, REGION_LABELS } from "./directory";

// /locations/ — every Alberta community we serve, grouped by region. The canonical crawl path to all 56 city hubs.
export default function LocationsPage() {
  const ld = { "@context": "https://schema.org", "@type": "CollectionPage", name: "Mortgage brokers across Alberta", url: `${MAIN_SITE_URL}/locations/`,
    hasPart: Object.values(REGIONS).flat().map((s) => ({ "@type": "WebPage", name: `${cityName(s)} mortgage broker`, url: `${MAIN_SITE_URL}/${s}/` })) };
  return (
    <SiteLayout>
      <SeoHead title="Mortgage Brokers Across Alberta | Every Community We Serve | Hello Mortgage Team" description="Edmonton-based, Alberta-wide. Find your community—from Calgary to Fort McMurray—and see local rates, market snapshots and first-time buyer help." path="/locations/" />
      <Helmet><script type="application/ld+json">{JSON.stringify(ld)}</script></Helmet>
      <section className="hero solution-hero" data-testid="locations-hero">
        <div className="hero-grid wrap solution-hero-grid"><div>
          <div className="eyebrow">Locations · Alberta</div>
          <h1 style={{ fontSize: "clamp(2.6rem,4.8vw,4.2rem)" }}>Alberta-wide. Edmonton-based. Always local.</h1>
          <p>We’re headquartered in Edmonton and work with buyers and homeowners in every corner of the province. Pick your community for local rates, market snapshots and the plays that work where you live.</p>
        </div></div>
      </section>
      <section className="locations-body"><div className="wrap">
        {Object.entries(REGIONS).map(([region, slugs]) => (
          <div className="locations-region" key={region} data-testid={`locations-region-${region}`}>
            <div className="eyebrow">{REGION_LABELS[region]}</div>
            <div className="locations-grid">
              {slugs.map((s) => (
                <div className="locations-card" key={s}>
                  <SmartLink href={`/${s}/`} className="locations-city" data-testid={`locations-city-${s}`}>{cityName(s)}</SmartLink>
                  <div className="locations-links"><SmartLink href={`/${s}/mortgage-rates/`}>Rates</SmartLink><SmartLink href={`/${s}/first-time-home-buyers/`}>First home</SmartLink></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div></section>
      <HowItWorks />
      <FinalCta />
    </SiteLayout>
  );
}
